import request from ".";

// 获取所有店铺
function getAll(){
  return request('/config-service/storeConfig/getAll', 'post')
}

/**添加店铺 */
function add(data){
  return request('/config-service/storeConfig/add', 'post', data)
}

/**更新店铺 */
function updata(data){
  return request('/config-service/storeConfig/update', 'post', data)
}

/**删除店铺 */
function deleteStore(data){
  return request('/config-service/storeConfig/delete', 'post', data)
}

export default{
  getAll, add, updata, deleteStore
}
